import { computed, type App, type ComputedRef } from 'vue'
import { useLanguageStore, type Language } from '@/stores/settings/language'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $lang: {
      th: boolean
      en: boolean
      value: Language
    }
  }
}

export default {
  install: (app: App) => {
    const languageStore = useLanguageStore()

    Object.defineProperty(app.config.globalProperties, '$lang', {
      get() {
        return computed(() => ({
          th: languageStore.language === 'th',
          en: languageStore.language === 'en',
          value: languageStore.language,
        })).value
      },
    })
  },
}
